import { useAuth } from "../../context/AuthProvider";
import { Route, Routes } from "react-router-dom";
import UnAuthRoutes from "../../routes/UnauthenticatedRoutes";
import LoadingPanel from "../../custom-components/CustomLoader";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { environment } from "../../environments/environment";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ProtectedRoute from "../../routes/ProtectedRoute";
import Account from "../../pages/Account";


const queryClient = new QueryClient();

function App() {
    const { loading } = useAuth();

    if (loading) {
        return <LoadingPanel isVisible={loading} />;
    }

    return (
        <GoogleOAuthProvider clientId={environment.GOOGLE_CLIENT_ID!}>
            <QueryClientProvider client={queryClient}>
                <Routes>
                    <Route path="/*" element={<UnAuthRoutes />} />
                    <Route element={<ProtectedRoute />}>
                        <Route path="/account" element={<Account />} />
                    </Route>
                </Routes>
            </QueryClientProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
